<template>
  <v-app
    id="inspire"
    class="primary-color"
  >
    <v-content>
      <v-layout
        align-center
        justify-center
      >
        <v-row
          xs12
          sm12
          md4
          justify="space-around"
        >
          <v-card
            class="login-card primary-color"
            width="100%"
            max-width="400px"
          >
            <v-row
              align="center"
              justify="center"
            />
            <v-toolbar
              color="toolbarBase"
              dark
              flat
            >
              <v-toolbar-title>Login</v-toolbar-title>
              <v-spacer />
              <v-tooltip right>
                <template />
              </v-tooltip>
            </v-toolbar>

            <v-card-text>
              <v-form
                v-model="valid"
                ref="form"
              >
                <v-row
                  v-if="!identifierVoter"
                >
                  <v-select
                    prepend-icon="search"
                    @change="onChange($event)"
                    :items="identifiers"
                    label="Selecione o tipo autenticação"
                    v-model="typeIdentifier"
                    :readonly="locked"
                    :rules="[selectIdentifierNotSelected]"
                    dense
                  />
                  <v-col cols="12">
                    <v-alert
                      v-model="alert"
                      border="left"
                      close-text="Fechar alerta"
                      dismissible
                      max-width="400px"
                      class="login-nopass-alert"
                      v-show="electionMessage"
                    >
                      <div class="subtitle-2">{{electionMessage}}</div>
                      <!-- <div class="subtitle-2">Exemplo:</div>
                      <div class="subtitle-2">RF: 00.123-6</div>
                      <div class="subtitle-2">Login: p000123</div> -->
                    </v-alert>
                  </v-col>
                  <v-text-field
                    prepend-icon="lock"
                    :label="identifierDescripttion"
                    name="identifier"
                    id="identifier"
                    v-model="identifier"
                    :rules="[validateIdentifier]"
                    required
                    clearable
                    @keypress="isNumber($event)"
                  />
                </v-row>
                <v-row
                  v-if="identifierVoter"
                >
                  <v-text-field
                    label="Eleitor"
                    v-model="nameVoter"
                    disabled
                  />
                </v-row>

                <ValidatePersonalData ref="validatePD" />

                <InformPassword ref="informPassword" />

                <ValidateRecaptcha ref="validateR" />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="toolbarBase white--text"
                @click="signin"
                tile
                block
                type="submit"
              >Acessar</v-btn>
            </v-card-actions>
            <v-card-actions
              v-show="resetPassword"
            >
              <v-spacer />
              <v-btn
                tile
                block
                type="button"
                color="toolbarBase"
                @click="passwordReset"
                outlined
              >
                Redefinir senha
              </v-btn>
            </v-card-actions>
            <p style="font-size: 10px; margin-left:5%; margin-right: 5%;">
              Este site é protegido pelo reCAPTCHA e pelas
              <a href="https://policies.google.com/privacy">Políticas de Privacidade</a> e
              <a href="https://policies.google.com/terms">Termos de Serviço</a> do Google.
            </p>
          </v-card>
        </v-row>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ValidatePersonalData from '@/components/security/ValidatePersonalData';
import ValidateRecaptcha from '@/components/security/ValidateRecaptcha';
import InformPassword from '@/components/security/InformPassword';

export default {
  name: 'LoginWithoutPass',
  components: {
    ValidatePersonalData,
    ValidateRecaptcha,
    InformPassword
  },
  data: () => ({
    alert: true,
    valid: false,
    user: '',
    identifierDescripttion: '',
    identifier: '',
    typeIdentifier: '',
    maxLength: 12,
    requiredRules: [v => !!v || 'Campo obrigatório'],
    identifiers: ['Identificador'],
    locked: false,
    password: null,
    identifierVoter: null,
    nameVoter: '',
    electionMessage: undefined,
    resetPassword: false
  }),
  computed: {
    ...mapGetters('login', ['isAuthenticated', 'userName'])
  },
  watch: {
    identifierVoter(value) {
      this.$refs.validateR.load(this.$store.state.election.confirmRecaptcha && !value);
    }
  },
  mounted() {
    this.typeIdentifier = 'Identificador';
    this.identifierDescripttion = 'Digite o identificador';
    this.identifierVoter = false;
    this.resetPassword = this.$store.state.election.resetPassword;
    this.electionMessage = this.$store.state.election.electionMessage;
    const showAlertManyVotes = (this.$store.state.election.votesPerVoter > 1) || (this.$store.state.election.candidate_roles_total > 1);
    this.$store.commit('setShowAlertManyVotes', showAlertManyVotes);
  },
  methods: {
    ...mapActions('login', { actionIdentifierLogin: 'identifierLogin', actionLogin: 'login' }),
    signin() {
      if (this.$refs.form.validate()) {
        if (!this.$store.state.login.voterId) {
          this.identificarEleitor();
        } else {
          this.login();
        }
      }
    },
    async login() {
      var params = {
        id: this.$store.state.login.voterId,
        election_id: this.$store.state.election.id,
        existPassword: this.$store.state.login.existPassword,
        recaptcha: this.recaptcha,
        loginPersonalData: this.$store.state.election.loginPersonalData,
        loginAzureAd: this.$store.state.election.loginAzureAd
      };
      const bFlagPersonalData = this.$refs.validatePD.validatePersonalData();
      const bFlagPassword = this.$refs.informPassword.verifyPassword();
      const entityPersonalData = this.$refs.validatePD.getValues();
      const entityPassword = this.$refs.informPassword.getValue();
      if (entityPersonalData) {
        params = Object.assign({}, params, entityPersonalData);
      }
      if (entityPassword) {
        params = Object.assign({}, params, entityPassword);
      }
      if (bFlagPersonalData && bFlagPassword) {
        try {
          await this.actionLogin(params);
          if (this.$store.state.login.accessValid && this.$store.state.login.hasVoted) {
            this.$store.commit('setShowAlertManyVotes', false);
            this.$router.push({ name: 'Vote' });
          } else if (this.$store.state.login.accessValid) {
            if (this.$store.state.election.Mosaico) {
              this.$router.push({ name: 'MosaicUrn' });
            } else {
              this.$router.push({ name: 'Urna' });
            }
          } else {
            alert('acesso não permitido');
          }
        } catch (error) {
          this.$refs.validateR.resetRecaptcha();
          alert(error);
        }
      }
    },
    async identificarEleitor() {
      if (this.$refs.form.validate()) {
        let params = {
          user: this.identifier,
          typeIdentifier: this.typeIdentifier,
          election_id: this.$store.state.election.id
        };
        const bVerifyRecaptcha = await this.$refs.validateR.verifyRecaptcha();
        const jsonRecaptcha = this.$refs.validateR.getRecaptcha();
        params = Object.assign({}, params, jsonRecaptcha);
        if (bVerifyRecaptcha) {
          try {
            await this.actionIdentifierLogin(params);
            this.nameVoter = this.$store.state.login.voterName;
            const jsonPersonalData = this.$store.state.login.entityPersonalData;
            this.$refs.validatePD.load(jsonPersonalData);
            this.$refs.informPassword.load(this.$store.state.login.informPassword);
            this.identifierVoter = true;
          } catch (error) {
            this.$refs.validateR.resetRecaptcha();
            alert(error);
          }
        }
      }
    },
    isNumber(event) {
      if (this.typeIdentifier === 'CPF') {
        if (
          /\D/.test(event.key) ||
          (this.identifier && this.identifier.length === this.maxLength)
        ) {
          event.preventDefault();
        }
      }
    },
    isValid() {
      return this.$refs.form.validate();
    },
    onChange(value) {
      this.typeIdentifier = value;
      this.identifierDescripttion = 'Digite a ' + value;
      this.identifier = '';
    },
    validateIdentifier(value) {
      if (this.typeIdentifier === 'E-mail') return this.validateEmail(value);
      else if (this.typeIdentifier === 'CPF') return this.validateCPF(value);
      else if (this.typeIdentifier === 'RG') return this.validateRG(value);
      if (!this.identifier) {
        return 'O identificador deve ser informado.';
      }
      return true;
    },
    validateEmail(value) {
      if (!value.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/)) {
        return false;
      }
      return true;
    },
    selectIdentifierNotSelected(value) {
      var msg = 'Selecione o tipo de autenticação.';
      if (value instanceof Array && value.length === 0) {
        return msg;
      }
      return !!value || msg;
    },
    passwordReset() {
      this.$router.push({ name: 'PasswordResetRequest' });
    }
  }
};
</script>
<style>
  .v-application--wrap {
    min-height: 82vh !important;
  }
</style>
